import React from 'react';
import { DateTime } from 'src_common/utils/time/time';

import { TabMenuItemType } from './config';
import { observer } from 'src/utils/mobx-react';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';

const getSportLabel = (eventModel: EventModel | null): string => {
    if (eventModel === null) {
        return '';
    }

    return eventModel.sport.substr(0, 2).toUpperCase();
};

const getCompetitionName = (appState: AppState, eventModel: EventModel | null): string => {
    if (eventModel === null) {
        return '.';
    }

    const competition = appState.sdkStaff.models.getCompetitionModel(eventModel.competition);
    const competitionName = competition === null ? '' : competition.name;
    return competitionName;
};

const getTime = (eventModel: EventModel | null, startTime: number): [string, string] => {
    const timestamp = eventModel === null ? startTime : eventModel.timeSettingsStartTime;
    const time = DateTime.from(timestamp);

    if (time === null) {
        return ['-', '-'];
    }

    return [time.format('HH:mm'), time.format("Do MMM 'YY")];
};

interface PropsType {
    eventId: number;
    eventName: string;
    startTime: number;
    columns: Array<TabMenuItemType>;
}

export const TradingEventsListRow = observer('TradingEventsListRow', (props: PropsType): React.ReactElement | null => {
    const appState = useAppStateContext();

    const { eventId, eventName, startTime, columns } = props;

    const isOpened = appState.sportsbookState.eventPageState.openedEvents.includes(eventId);

    const eventModel = appState.sdkStaff.models.getEvent(eventId);

    const onOpen = (e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>): void => {
        e.preventDefault();
        appState.routerBackoffice.redirectToTradingEvent(eventId);
        appState.sportsbookState.eventPageState.addEvent(eventId);
        appState.sportsbookState.eventPageState.addToRecentlyViewed(eventId);
    };

    const onToggle = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        if (isOpened) {
            appState.sportsbookState.eventPageState.removeEvent(eventId);
        } else {
            appState.sportsbookState.eventPageState.addEvent(eventId);
            appState.sportsbookState.eventPageState.addToRecentlyViewed(eventId);
        }
    };

    const [time1, time2] = getTime(eventModel, startTime);

    const columntsJsx = [];

    for (const column of columns) {
        columntsJsx.push(
            <td
                key={column.key}
                className='trading-events-list-table-additional llloool'
            >
                {column.definition(eventId)}
            </td>
        );
    }

    return (
        <tr>
            <td className='trading-events-list-table-open'>
                <a
                    href='#'
                    onClick={onToggle}
                >
                    {isOpened ? '-' : '+'}
                </a>
            </td>
            <td className='trading-events-list-table-time'>
                <strong>{time1}</strong>
                {time2}
            </td>
            <td className='trading-events-list-table-sport'>{getSportLabel(eventModel)}</td>
            <td
                className='trading-events-list-table-name'
                onClick={onOpen}
            >
                <strong>{eventModel?.name ?? eventName}</strong>
                {getCompetitionName(appState, eventModel)}
            </td>
            {columntsJsx}
        </tr>
    );
});
